import utils = egr.wcf.utils;

const MESSAGE_HANDLERS: {[id: string]: MessageHandlerSignature | undefined} = {};

export type UnregisterCallback = () => void;

type MessageHandlerSignature = (event: MessageEvent) => void;

interface MessageHandler {
    type: string;
    callback: MessageHandlerSignature;
}

export function registerHandler(handler: MessageHandler): UnregisterCallback {
    if (MESSAGE_HANDLERS[handler.type] !== undefined) {
        throw new Error('A message handler with this type has already been registered.');
    }

    MESSAGE_HANDLERS[handler.type] = handler.callback;

    return (): void => {
        delete MESSAGE_HANDLERS[handler.type];
    };
}

export function receiveMessage(event: MessageEvent): void {
    if (event.data != null && utils.string.isNotNullOrEmpty(event.data.type)) {
        const callback: MessageHandlerSignature | undefined = MESSAGE_HANDLERS[event.data.type];
        if (callback !== undefined) {
            callback(event);
        }
    }
}

window.addEventListener('message', receiveMessage, false);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/app-api/MessageManager.ts